import { plainToInstance } from "class-transformer";
import ApiAccountProfilePersistedBase from "@rmp/core/api/types/account/apiAccountProfilePersistedBase";
import BaseOrganizationController from "@rmp/core/api/base/baseOrganizationController";
import AbortService from "@rmp/core/services/abortService";

export class AccountController extends BaseOrganizationController {
	constructor(abortService: AbortService) {
		super(abortService);
	}

	getAccountProfiles = async (): Promise<ApiAccountProfilePersistedBase[]> => {
		const { data: { profiles } } = await this.api.account.profileListByRequest({});

		return plainToInstance(ApiAccountProfilePersistedBase, profiles);
	};
}
